module.exports = __webpack_public_path__ + "img/servicio_complementario.eb0d8100.png";